import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalDetallesCuentasComponent } from '../modal-detalles-cuentas/modal-detalles-cuentas.component';
import { basicAlert } from '../../utils';

@Component({
  selector: 'app-md-doc-cuenta-cobrar',
  templateUrl: './md-doc-cuenta-cobrar.component.html',
  styleUrls: ['./md-doc-cuenta-cobrar.component.css']
})
export class MdDocCuentaCobrarComponent implements OnInit {
  cuentasPorCobrar:any[]=[];
  constructor(private modalServicemodal: NgbActiveModal,
    private readonly spinnerService: SpinnerService,
    private ctaCobrarConsultasService: CuentaPorCobrarService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
  }
  cancelar() {
    this.modalServicemodal.dismiss('canceling');
  }
  esttemp
  onClick(data: any): void {
    this.esttemp = data;
  }
  detalles(est: any) {
    console.log(est)
    this.esttemp = est;
    //  DETALLE DOCUMENTOS
    this.ctaCobrarConsultasService.getDetalleEECC(est.codcli, false, true, '', est.numint).subscribe((response: any) => {
      console.log("detalle cargado")
      console.log(response);
      // this.estadocuenta2 = response.body.list;
      const referenciaModal = this.modalService.open(ModalDetallesCuentasComponent, { scrollable: true, windowClass: 'modal-large-detalle', backdrop: 'static' });
      referenciaModal.componentInstance.detalles = response.body.list;
      referenciaModal.componentInstance.tipo = "Cobrar";

      this.spinnerService.activarLoading(false);

    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert('No se encontró detalles para el Interlocutor seleccionado', 'warning', 'Aceptar');

    });
  }
}
